import { render, staticRenderFns } from "./WaitForModeratorDialogue.vue?vue&type=template&id=73968d77&scoped=true&"
import script from "./WaitForModeratorDialogue.vue?vue&type=script&lang=js&"
export * from "./WaitForModeratorDialogue.vue?vue&type=script&lang=js&"
import style0 from "./WaitForModeratorDialogue.vue?vue&type=style&index=0&id=73968d77&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73968d77",
  null
  
)

export default component.exports